export const load = () => ({
	title: 'Block Pickle Noise',
	showTitle: false,
});
